export default "__VITE_ASSET__qIzN0kqn__"